import { BehaviorParameters } from 'rangeConfig/@types';

const replaceDoor = ({ coreApi, props, rootState }: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();
  if (!selectedEntity) {
    return;
  }

  const productType = coreApi.entities.getProductType(selectedEntity);

  const replacementProductType = rootState.products.inMarket.find(
    p => p.coreProductId === props.coreProductId
  )?.type;
  if (productType === replacementProductType) {
    // If same type of door we do a regular replace product
    const replacePlacementResult = coreApi.products.replace(selectedEntity.id, props.coreProductId);
    if (replacePlacementResult?.replacedEntityResult.placedEntity) {
      coreApi.entities.select(replacePlacementResult.replacedEntityResult.placedEntity);
    }
  } else {
    // If different type of door (replaceing panel and regular sliding door) we do a remove and add
    const replacePlacementResult = coreApi.products.removeAndAdd(
      selectedEntity.id,
      props.coreProductId
    );
    if (replacePlacementResult?.placedEntity) {
      coreApi.entities.select(replacePlacementResult.placedEntity);
    }
  }
};

export default replaceDoor;
